import { Form, FormType, WizardItemType, Zone } from '@gimlite/ui-v1';
import { useEffect, useState } from 'react';
import { ContractWizardInfos } from '../../../../composition/wizard-infos/contract.wizard-infos';
import { ContractBaseForm } from '../../../../form/contract-create/contract-create.form';
import { CreateNewSubPoolContractContext } from '../../createNewSubPoolContract.wizard';

export const ContractStep = ({
  context: { parentContract, contractBase, product },
  validate,
  submit,
}: WizardItemType.Config.Component<CreateNewSubPoolContractContext>) => {
  const [instance, setInstance] = useState<
    FormType.HandleEvent.Instance['value1'] | null
  >(null);

  useEffect(() => {
    if (parentContract && !contractBase.articleCode) {
      submit({
        contractBase: {
          ...contractBase,
          articleCode: parentContract.articleCode,
        },
      });
    }
  }, [parentContract, contractBase]);

  useEffect(() => {
    if (instance) {
      instance.validateFields({
        validateOnly: true,
        dirty: false,
        recursive: true,
      });
    }
  }, [instance]);

  return (
    <Form
      data={{ value: contractBase }}
      config={{ validateOnChange: true }}
      handleEvent={{
        change: (value: any) => {
          let contractFormatted = value;

          if (contractFormatted.APBMode === 'NONE') {
            contractFormatted = {
              ...contractFormatted,
              APBNext: null,
            };
          } else if (
            contractFormatted.APBMode !== 'NONE' &&
            [null, undefined].includes(contractFormatted.APBNext)
          ) {
            contractFormatted = {
              ...contractFormatted,
              APBNext: true,
            };
          }

          submit({ contractBase: contractFormatted });
        },
        validate: (value: boolean) => {
          validate(value);
        },
        instance: (form) => {
          setInstance(form);
        },
      }}
    >
      <Zone
        config={{
          gap: {
            y: 1,
            x: 1,
          },
          zones: [['info', 'form']],
          rows: ['1fr'],
          columns: ['min-content', '1fr'],
        }}
      >
        <Zone.Area config={{ area: 'info' }}>
          <ContractWizardInfos
            data={{
              APBMode: contractBase.APBMode,
              APBNext:
                contractBase.APBMode !== 'NONE' ? contractBase.APBNext : null,
              state: contractBase.state,
              startDate: contractBase.startDate,
              endDate: contractBase.endDate,
              description: contractBase.description,
              reference: contractBase.reference,
              articleCode: contractBase.articleCode,
            }}
          />
        </Zone.Area>

        {parentContract && contractBase.articleCode && (
          <Zone.Area config={{ area: 'form' }}>
            <ContractBaseForm
              data={{
                contract: contractBase,
              }}
              config={{
                parentContract,
                articleCodes: product.articleCodes,
                withCapacity: true,
              }}
            />
          </Zone.Area>
        )}
      </Zone>
    </Form>
  );
};
